import React, { Component } from "react";
import { connect } from "react-redux";
import { Button, Col, Collapse, DatePicker, Empty, Form, Icon, Row, Select, Skeleton, Spin, Table, Tooltip } from "antd";
import { Link } from "react-router-dom";
import * as moment from 'moment';

import { getAssetSpareIssueReport } from "../../appRedux/actions/Common";
import { fetchRelationshipSearchData, getSpareInventoryFilters } from "../../appRedux/actions/index";
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

const { Panel } = Collapse;

class AssetSpareIssueReport extends Component {
    state = {
        searchType: '',
        selectedAsset: null,
        selectedAssetModel: null,
        selectedAssetSubType: null,
        selectedAssetType: null,
        assetList: [],
        modelList: [],
        subTypeList: [],
        typeList: [],
        disableAsset: false,
        disableAssetModel: false,
        disableAssetSubType: false,
        disableAssetType: false,
        searchText: '',
        searchedColumn: '',
        fetchedIssueData: [],
        fetchedIssueDataColFilters: {},
        value: [],
        searchData: {},
    };

    componentWillReceiveProps(nextProps) {
        if (nextProps && nextProps.spareIssueData && JSON.stringify(nextProps.spareIssueData) !== JSON.stringify(this.props.spareIssueData)) {
            const filterData = {};
            if (nextProps.spareIssueData && nextProps.spareIssueData.length) {
                nextProps.spareIssueData.map(issue => {
                    for (const [key, value] of Object.entries(issue)) {
                        if (filterData[key] && filterData[key].length) {
                            if (!filterData[key].includes(value))
                                filterData[key].push(value);
                        } else
                            filterData[key] = [value];
                    }
                });
                filterData['equipmentSubType'] = [];
                filterData['assetType'] = [];
                filterData['asset'].map(ast => {
                    if (!filterData['equipmentSubType'].includes(ast['equipmentSubType'].name))
                        filterData['equipmentSubType'].push(ast['equipmentSubType'].name);
                    if (!filterData['assetType'].includes(ast['equipmentSubType']['assetType'].name))
                        filterData['assetType'].push(ast['equipmentSubType']['assetType'].name);
                })
            }
            this.setState({
                fetchedIssueData: nextProps.spareIssueData,
                fetchedIssueDataColFilters: filterData,
            })
        }

        if (nextProps && nextProps.assetData && JSON.stringify(nextProps.assetData) !== JSON.stringify(this.props.assetData)) {
            if (this.state.searchType === 'Asset')
                this.setState({
                    assetList: nextProps.assetData
                });
            if (this.state.searchType === 'AssetModel')
                this.setState({
                    modelList: nextProps.assetData
                });
            if (this.state.searchType === 'AssetSubType')
                this.setState({
                    subTypeList: nextProps.assetData
                });
            if (this.state.searchType === 'AssetType')
                this.setState({
                    typeList: nextProps.assetData
                });
        }
    }

    handleSubmit = e => {
        e.preventDefault();
        e.stopPropagation();
        this.props.form.validateFields((err, values) => {
            if (err) {
            } else {
                const {
                    selectedAsset, selectedAssetModel, selectedAssetSubType, selectedAssetType, searchType
                } = this.state;
                if ((selectedAsset || selectedAssetModel || selectedAssetSubType || selectedAssetType) && searchType) {
                    // console.log(selectedAsset, selectedAssetModel, selectedAssetSubType, selectedAssetType);
                    this.props.getAssetSpareIssueReport((selectedAsset && selectedAsset._id) || (selectedAssetModel && selectedAssetModel._id)
                        || (selectedAssetSubType && selectedAssetSubType._id) || (selectedAssetType && selectedAssetType._id), searchType);
                }
            }
        });
    };

    downloadCsv = async () => {
        const tableData = this.state.fetchedIssueData;
        const fileType =
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        const fileExtension = '.xlsx';
        if (tableData && tableData.length) {
            let arr = [];
            for (let i = 0; i < tableData.length; i++) {
                let asset = tableData[i]['asset'];
                let spare = tableData[i]['spare'];
                let obj = {};
                obj.Sno = i + 1;
                obj['date'] = tableData[i].date && moment(tableData[i].date).format('DD-MM-YYYY') || '';
                obj['category_no'] = tableData[i].category_no || '';
                obj['jobCardNo'] = tableData[i].jobCardNo || '';
                obj['spare'] = spare && spare.name || '';
                obj['quantity'] = tableData[i].quantity || 0;
                obj['rate'] = tableData[i].rate || 0;
                obj['location'] = tableData[i].location || '';
                obj['asset'] = asset && asset.assetCode || '';
                obj['assetType'] = asset.equipmentSubType.assetType && asset.equipmentSubType.assetType.name || '';
                obj['assetSubType'] = asset.equipmentSubType && asset.equipmentSubType.name || '';
                arr.push(obj);
            }
            const ws = XLSX.utils.json_to_sheet(arr);
            const wb = { Sheets: { report: ws }, SheetNames: ['report'] };
            const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
            const data = new Blob([excelBuffer], { type: fileType });
            FileSaver.saveAs(
                data,
                `spare-issue-report-${Date.now()}${fileExtension}`,
            );
        }
    };

    resetForm = (form) => {

        this.setState({
            disableAsset: false,
            disableAssetModel: false,
            disableAssetSubType: false,
            disableAssetType: false,
            selectedAsset: null,
            selectedAssetModel: null,
            selectedAssetSubType: null,
            selectedAssetType: null,
            assetList: [],
            modelList: [],
            subTypeList: [],
            typeList: [],
        });
        form.setFieldsValue({
            asset: '',
            assetModel: '',
            assetSubType: '',
            assetType: ''
        });

    };

    handleSelect = (type, value) => {
        const { setFieldsValue } = this.props.form;
        switch (type) {
            case 'asset':
                const selectedAsset = this.props.assetData.filter(asset => asset._id === value);
                this.setState({
                    selectedAsset: selectedAsset[0] || null,
                    modelList: selectedAsset[0] && selectedAsset[0].assetModel ? [selectedAsset[0].assetModel] : [],
                    subTypeList: selectedAsset[0] && selectedAsset[0].equipmentSubType ? [selectedAsset[0].equipmentSubType] : [],
                    typeList: selectedAsset[0] && selectedAsset[0].equipmentSubType && selectedAsset[0].equipmentSubType.assetType ? [selectedAsset[0].equipmentSubType.assetType] : [],
                    // selectedAssetModel: selectedAsset[0].assetModel || null,
                    // selectedAssetSubAssembly: selectedAsset[0].assetModel.subAssembly || null,
                    disableAssetModel: true,
                    disableAssetSubType: true,
                    disableAssetType: true,
                });
                setFieldsValue({
                    assetModel: selectedAsset[0] && selectedAsset[0].assetModel && selectedAsset[0].assetModel._id,
                    assetSubType: selectedAsset[0] && selectedAsset[0].equipmentSubType && selectedAsset[0].equipmentSubType._id,
                    assetType: selectedAsset[0] && selectedAsset[0].equipmentSubType && selectedAsset[0].equipmentSubType.assetType && selectedAsset[0].equipmentSubType.assetType._id,
                });
                break;
            case 'assetModel':
                const selectedAssetModel = this.props.assetData.filter(model => model._id === value);
                this.setState({
                    selectedAsset: null,
                    selectedAssetModel: selectedAssetModel[0] || null,
                    assetList: [],
                    subTypeList: selectedAssetModel[0] && selectedAssetModel[0].assetSubType ? [selectedAssetModel[0].assetSubType] : [],
                    typeList: selectedAssetModel[0] && selectedAssetModel[0].assetSubType && selectedAssetModel[0].assetSubType.assetType ? [selectedAssetModel[0].assetSubType.assetType] : [],
                    // selectedAssetModel: selectedAsset[0].assetModel || null,
                    // selectedAssetSubAssembly: selectedAsset[0].assetModel.subAssembly || null,
                    disableAsset: true,
                    disableAssetSubType: true,
                    disableAssetType: true,
                });
                setFieldsValue({
                    asset: null,
                    // assetModel: selectedAsset[0] && selectedAsset[0].assetModel && selectedAsset[0].assetModel._id,
                    assetSubType: selectedAssetModel[0] && selectedAssetModel[0].assetSubType && selectedAssetModel[0].assetSubType._id,
                    assetType: selectedAssetModel[0] && selectedAssetModel[0].assetSubType && selectedAssetModel[0].assetSubType.assetType && selectedAssetModel[0].assetSubType.assetType._id,
                });
                break;
            case 'assetSubType':
                const selectedAssetSubType = this.props.assetData.filter(subType => subType._id === value);
                this.setState({
                    selectedAsset: null,
                    selectedAssetModel: null,
                    selectedAssetSubType: selectedAssetSubType[0] || null,
                    assetList: [], modelList: [],
                    // subTypeList: selectedAssetModel[0] && selectedAssetModel[0].assetSubType ? [selectedAssetModel[0].assetSubType] : [],
                    typeList: selectedAssetSubType[0] && selectedAssetSubType[0].assetType ? [selectedAssetSubType[0].assetType] : [],
                    // selectedAssetModel: selectedAsset[0].assetModel || null,
                    // selectedAssetSubAssembly: selectedAsset[0].assetModel.subAssembly || null,
                    disableAsset: true,
                    disableAssetModel: true,
                    disableAssetType: true,
                });
                setFieldsValue({
                    asset: null,
                    assetModel: null,
                    // assetSubType: selectedAssetModel[0] && selectedAssetModel[0].assetSubType && selectedAssetModel[0].assetSubType._id,
                    assetType: selectedAssetSubType[0] && selectedAssetSubType[0].assetType && selectedAssetSubType[0].assetType._id,
                });
                break;
            case 'assetType':
                const selectedAssetType = this.props.assetData.filter(subType => subType._id === value);
                this.setState({
                    selectedAsset: null,
                    selectedAssetModel: null,
                    selectedAssetSubType: null,
                    selectedAssetType: selectedAssetType[0] || null,
                    assetList: [], modelList: [], subTypeList: [],
                    // subTypeList: selectedAssetModel[0] && selectedAssetModel[0].assetSubType ? [selectedAssetModel[0].assetSubType] : [],
                    // typeList: selectedAssetSubType[0] && selectedAssetSubType[0].assetType ? [selectedAssetSubType[0].assetType] : [],
                    // selectedAssetModel: selectedAsset[0].assetModel || null,
                    // selectedAssetSubAssembly: selectedAsset[0].assetModel.subAssembly || null,
                    disableAsset: true,
                    disableAssetModel: true,
                    disableAssetSubType: true,
                });
                setFieldsValue({
                    asset: null,
                    assetModel: null,
                    assetSubType: null,
                    // assetType: selectedAssetType[0] && selectedAssetType[0]._id,
                });
                break;
            default:
        }
    };

    fetchSearch = (value, type = 'Asset') => {
        // console.log(value, type);
        this.setState({ searchType: type });
        if (value && value.length >= 3) {
            if (type === 'Asset')
                this.props.fetchRelationshipSearchData(value, 'Asset', 'assetCode');
            else if (type === 'AssetModel')
                this.props.fetchRelationshipSearchData(value, 'AssetModel', 'name');
            else if (type === 'AssetSubType')
                this.props.fetchRelationshipSearchData(value, 'EquipmentSubType', 'name');
            else if (type === 'AssetType')
                this.props.fetchRelationshipSearchData(value, 'AssetType', 'name');
        }
    };
    //
    // handleSearch = (selectedKeys, confirm, dataIndex) => {
    //   confirm();
    //   this.setState({
    //     searchText: selectedKeys,
    //     searchedColumn: dataIndex,
    //   });
    // };
    //
    // handleReset = clearFilters => {
    //   clearFilters();
    //   this.setState({searchText: ''});
    // };

    handleChange = (value, setSelectedKeys, dataIndex) => {
        // console.log(value);
        let data = this.state.searchData;
        data[dataIndex] = [];
        this.setState({ value, searchData: data });
        setSelectedKeys(value ? value : []);
    };

    searchClicked = (selectedKeys, confirm, data) => {
        confirm();
        this.setState({ value: [] });
        // this.props.handleFilter(selectedKeys, confirm, data);
    };

    handleDateWiseFilter = (selectedKeys, confirm) => {
        // console.log(selectedKeys, this.state.value);
        confirm();
        // this.setState({value: []});

        // const data = this.state.fetchedIssueData;
        // console.log(date, data, confirm);
        // if(date && date.length) {
        //   this.setState({
        //     fetchedIssueData: data.filter(doc => moment(doc.date).isBetween(date[0], date[1], undefined, '[]'))
        //   })
        // }else{
        //   this.setState({
        //     fetchedIssueData: data;
        //   })
        // }
    };

    resetClicked = (clearFilters, data) => {
        clearFilters();
        this.setState({ value: [] });
        // this.props.handleReset(clearFilters, data);
    };

    fetchSelect = (value, filterData, select, index) => {
        // console.log(filterData, value, select);
        if (value && filterData && filterData.length) {
            let searchData = {};
            searchData[index] = filterData.filter(doc => (doc.name + "").toLowerCase().indexOf((value + "").toLowerCase()) >= 0);
            this.setState({
                searchData: { ...this.state.searchData, ...{ searchData } }
            });
            // console.log(this.state.searchData);
        }
    };

    getColumnSearchProps = (dataIndex, dataType = 'String', filterData = [], select = '') => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => {
            if (dataType === 'String') {
                return (
                    <div style={{ padding: 8 }}>
                        <Select
                            ref={node => {
                                this.searchInput = node;
                            }}
                            showSearch
                            autoClearSearchValue
                            mode="multiple"
                            placeholder={'Select'}
                            filterOption={(input, option) => {
                                // console.log(option, input);
                                return (option.props.value + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0;
                            }}
                            value={selectedKeys}
                            // onChange={e => {
                            //   console.log(e);
                            //   setSelectedKeys(e ? [e] : [])
                            // }}
                            // onSearch={(val) => this.fetchSelect(val, filterData, select, dataIndex)}
                            onChange={(val) => this.handleChange(val, setSelectedKeys, dataIndex)}
                            // onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                            notFoundContent={null}
                            style={{ width: 188, marginBottom: 8, display: 'block' }}
                        >
                            {
                                filterData.map((item, index) => {
                                    if (select === '') {
                                        return (<Select.Option key={index} value={item}><Tooltip
                                            title={item}>{item}</Tooltip></Select.Option>);
                                    }
                                    if (select === 'name') {
                                        return (<Select.Option key={index} value={item.name}><Tooltip
                                            title={item.name}>{item.name}</Tooltip></Select.Option>);
                                    }
                                    if (select === 'assetCode') {
                                        return (<Select.Option key={index} value={item.assetCode}><Tooltip
                                            title={item.assetCode}>{item.assetCode}</Tooltip></Select.Option>);
                                    }
                                    if (select === 'equipmentSubType') {
                                        return (<Select.Option key={index} value={item.equipmentSubType.name}><Tooltip
                                            title={item.equipmentSubType.name}>{item.equipmentSubType.name}</Tooltip></Select.Option>);
                                    }
                                    if (select === 'assetType') {
                                        return (<Select.Option key={index} value={item.equipmentSubType.assetType.name}><Tooltip
                                            title={item.equipmentSubType.assetType.name}>{item.equipmentSubType.assetType.name}</Tooltip></Select.Option>);
                                    }
                                }
                                )}
                        </Select>
                        <Button
                            type="primary"
                            onClick={() => this.searchClicked(selectedKeys, confirm, dataIndex)}
                            icon="search"
                            size="small"
                            style={{ width: 90, marginRight: 8 }}
                        >
                            Search
                        </Button>
                        <Button onClick={() => this.resetClicked(clearFilters)} size="small" style={{ width: 90 }}>
                            Reset
                        </Button>
                    </div>
                )
            }
            if (dataType === 'Date') {
                return (
                    <div style={{ padding: 8, display: 'flex', flexDirection: 'column' }}>
                        <DatePicker.RangePicker
                            style={{ marginBottom: 8 }}
                            format={'DD-MM-YYYY'}
                            onChange={(date, dateString) => {
                                // console.log(date, dateString);
                                setSelectedKeys(date);
                                this.setState({ value: date });
                                // this.handleDateWiseFilter(date, confirm);
                            }} />
                        <Button
                            type="primary"
                            onClick={() => this.handleDateWiseFilter(selectedKeys, confirm, dataIndex)}
                            icon="search"
                            size="small"
                            style={{ width: 90, marginRight: 8 }}
                        >Search</Button>
                        <Button onClick={() => this.resetClicked(clearFilters)} size="small" style={{ width: 90 }}>
                            Reset
                        </Button>
                    </div>
                );
            }
        },
        onFilter: (value, record) => {
            if (dataType === 'String') {
                return (typeof record[dataIndex] === 'string') ? record[dataIndex]
                    .toString()
                    .toLowerCase()
                    .includes(value.toLowerCase())
                    :
                    (typeof record[dataIndex] === 'number') ? record[dataIndex] === value :
                        record[dataIndex]['name']
                            .toString()
                            .toLowerCase()
                            .includes(value.toLowerCase())
            } else {
                // console.log(value, record[dataIndex], this.state.value);
                const dateRange = this.state.value;
                if (dateRange && dateRange.length === 2) {
                    return moment(record[dataIndex]).isBetween(dateRange[0], dateRange[1], undefined, '[]');
                } else
                    return null;
            }
        }
    });

    cols = (filterData) => {
        return [
            {
                title: "Spare Issue Date",
                dataIndex: "date",
                key: "date",
                sorter: (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime(),
                render: (date) => date && moment(date).format('DD-MM-YYYY'),
                ...this.getColumnSearchProps('date', 'Date', filterData['date']),
            },
            {
                title: "Issue No",
                dataIndex: "category_no",
                key: "category_no",
                sorter: (a, b) => a.category_no.length - b.category_no.length,
                render: (category_no, record) => (
                    <span style={{ verticalAlign: 'center' }}>
                        {
                            record.category && record.category === 'issue' ? (
                                <Link target={'_blank'} to={`/spares-issue/edit/${record._id}`}>{category_no}</Link>)
                                : (<Link target={'_blank'} to={`/invoice-entry/edit/${record._id}`}>{category_no}</Link>)
                        }
                    </span>
                ),
                filterMultiple: true,
                ...this.getColumnSearchProps('category_no', 'String', filterData['category_no']),
            },
            {
                title: "Job Card",
                dataIndex: "jobCardNo",
                key: "jobCardNo",
                sorter: (a, b) => a.jobCardNo.length - b.jobCardNo.length,
                render: (jobCardNo, record) => (
                    <span style={{ verticalAlign: 'center' }}>
                        <Link target={'_blank'} to={`/job-card/report/${record.jobCardId}`}>{jobCardNo}</Link>
                    </span>
                ),
                filterMultiple: true,
                ...this.getColumnSearchProps('jobCardNo', 'String', filterData['jobCardNo']),
            },
            {
                title: "Spare Part",
                dataIndex: "spare",
                key: "spare",
                sorter: (a, b) => a.spare.name.length || 0 - b.spare.name.length || 0,
                render: (spare) => (
                    <span style={{ verticalAlign: 'center' }}>
                        <Link target={'_blank'} to={`/spare-part/edit/${spare && spare._id}`}>{spare && spare.name}</Link>
                    </span>
                ),
                filterMultiple: true,
                ...this.getColumnSearchProps('spare', 'String', filterData['spare'], 'name'),
            },
            {
                title: "",
                key: "action",
                width: '10',
                render: (_, record) => (
                    <span>
                        <Link target={'_blank'}
                            to={`/spare-part/history-report/spare/${record && record.spare && record.spare._id}`}>
                            <Tooltip
                                title={`View purchase history`}><Icon
                                    type="audit" style={{ color: 'black' }} /></Tooltip></Link>

                    </span>
                ),
            },
            {
                title: "Qty",
                dataIndex: "quantity",
                key: "quantity",
                sorter: (a, b) => a.quantity || 0 - b.quantity || 0,
                ...this.getColumnSearchProps('quantity', 'String', filterData['quantity']),
            },
            {
                title: "Rate",
                dataIndex: "rate",
                key: "rate",
                sorter: (a, b) => a.rate || 0 - b.rate || 0,
                ...this.getColumnSearchProps('rate', 'String', filterData['rate']),
            },
            {
                title: "Location",
                dataIndex: "location",
                key: "location",
                sorter: (a, b) => a.location.length || 0 - b.location.length || 0,
                render: (location) => location,
                ...this.getColumnSearchProps('location', 'String', filterData['location']),
            },
            {
                title: "Asset Code",
                dataIndex: "asset",
                key: "asset",
                sorter: (a, b) => a.asset.assetCode.length || 0 - b.asset.assetCode.length || 0,
                render: (asset) => (
                    <span style={{ verticalAlign: 'center' }}>
                        <Link target={'_blank'} to={`/asset/history-report/${asset && asset._id}`}>{asset && asset.assetCode}</Link>
                    </span>
                ),
                ...this.getColumnSearchProps('assetCode', 'String', filterData['assetCode'], ''),
            },
            {
                title: "Asset Type",
                dataIndex: "asset",
                key: "assetType",
                sorter: (a, b) => {
                    const aval = a.asset && a.asset.equipmentSubType && a.asset.equipmentSubType.assetType && a.asset.equipmentSubType.assetType.name || '';
                    const bval = b.asset && b.asset.equipmentSubType && b.asset.equipmentSubType.assetType && b.asset.equipmentSubType.assetType.name || '';
                    return aval.length - bval.length;
                },
                render: (asset) => asset && asset.equipmentSubType && asset.equipmentSubType.assetType && asset.equipmentSubType.assetType.name,
                ...this.getColumnSearchProps('asset', 'String', filterData['assetType'], ''),
            },
            {
                title: "Sub Type",
                dataIndex: "asset",
                key: "assetSubType",
                sorter: (a, b) => {
                    const aval = a.asset && a.asset.equipmentSubType && a.asset.equipmentSubType.name || '';
                    const bval = b.asset && b.asset.equipmentSubType && b.asset.equipmentSubType.name || '';
                    return aval.length - bval.length;
                },
                render: (asset) => asset && asset.equipmentSubType && asset.equipmentSubType.name,
                ...this.getColumnSearchProps('asset', 'String', filterData['equipmentSubType'], ''),
            },
        ];
    };

    handleShowPH = (spareId) => {
        if (spareId) {

        }
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        const { loading, assetData, spareIssueData } = this.props;
        const { fetchedIssueData, fetchedIssueDataColFilters } = this.state;
        // console.log(spareIssueData);
        let spareTable = <Skeleton active />;
        if (fetchedIssueDataColFilters && Object.keys(fetchedIssueDataColFilters) && Object.keys(fetchedIssueDataColFilters).length) {
            // console.log(fetchedIssueDataColFilters);
            spareTable =
                (fetchedIssueDataColFilters) ? (
                    <Table
                        dataSource={fetchedIssueData}
                        pagination={{ pageSize: 10 }}
                        columns={this.cols(fetchedIssueDataColFilters)}
                        loading={this.props.loading}
                        rowKey={(record) =>
                            (record._id || '') +
                            (record.spare && record.spare._id || '') +
                            (record.asset && record.asset._id || '') +
                            record.category_no +
                            record.rate +
                            record.quantity
                        }
                    />
                ) : null;
        } else spareTable = <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />;

        return (
            <div>
                <Spin spinning={loading}>
                    <Collapse bordered={false} defaultActiveKey={['1']} expandIconPosition={'right'}>
                        <Panel header="Spare Issue Report" key="1">
                            <div>
                                <Form
                                    onSubmit={this.handleSubmit}
                                    layout="inline"
                                >
                                    <Row>
                                        <Col xs={24} sm={12} md={6} lg={6} xl={6}>
                                            <Form.Item key={'asset'} label={'Asset'} style={{ width: '100%' }}>
                                                {getFieldDecorator(`asset`, {
                                                    // rules: [{required: true, message: `Asset is required!`}],
                                                    initialValue: null,
                                                })(<Select
                                                    showSearch
                                                    allowClear
                                                    disabled={this.state.disableAsset}
                                                    filterOption={(input, option) =>
                                                        (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                                                    }
                                                    onSearch={(val) => this.fetchSearch(val, 'Asset')}
                                                    onChange={value => this.handleSelect('asset', value)}
                                                    placeholder={`Please Enter Asset`}
                                                >
                                                    {assetData.map(item =>
                                                        <Select.Option key={item._id}
                                                            value={item._id}>{item.assetCode}</Select.Option>)}
                                                </Select>)
                                                }
                                            </Form.Item>
                                        </Col>

                                        <Col xs={24} sm={12} md={6} lg={6} xl={6}>
                                            <Form.Item key={'assetModel'} label={'Asset Model'} style={{ width: '100%' }}>
                                                {getFieldDecorator(`assetModel`, {
                                                    // rules: [{required: true, message: `Asset Model is required!`}],
                                                    initialValue: null,
                                                })(<Select
                                                    showSearch
                                                    allowClear
                                                    disabled={this.state.disableAssetModel}
                                                    filterOption={(input, option) =>
                                                        (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                                                    }
                                                    onSearch={(val) => this.fetchSearch(val, 'AssetModel')}
                                                    onChange={value => this.handleSelect('assetModel', value)}
                                                    placeholder={`Please Enter Asset Model`}
                                                >
                                                    {(this.state.modelList || []).map(item =>
                                                        <Select.Option key={item._id}
                                                            value={item._id}>{item.name}</Select.Option>)}
                                                </Select>)
                                                }
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} sm={12} md={6} lg={6} xl={6}>
                                            <Form.Item key={'assetSubType'} label={'Asset Sub Type'}
                                                style={{ width: '100%' }}>
                                                {getFieldDecorator(`assetSubType`, {
                                                    initialValue: null,
                                                })(<Select
                                                    showSearch
                                                    allowClear
                                                    disabled={this.state.disableAssetSubType}
                                                    filterOption={(input, option) =>
                                                        (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                                                    }
                                                    onSearch={(val) => this.fetchSearch(val, 'AssetSubType')}
                                                    onChange={value => this.handleSelect('assetSubType', value)}
                                                    placeholder={`Please Enter Asset Sub Type`}
                                                >
                                                    {(this.state.subTypeList || []).map(item =>
                                                        <Select.Option key={item._id}
                                                            value={item._id}>{item.name}</Select.Option>)}
                                                </Select>)
                                                }
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} sm={12} md={6} lg={6} xl={6}>
                                            <Form.Item key={'assetType'} label={'Asset Type'} style={{ width: '100%' }}>
                                                {getFieldDecorator(`assetType`, {
                                                    initialValue: null,
                                                })(<Select
                                                    showSearch
                                                    allowClear
                                                    disabled={this.state.disableAssetType}
                                                    filterOption={(input, option) =>
                                                        (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                                                    }
                                                    onSearch={(val) => this.fetchSearch(val, 'AssetType')}
                                                    onChange={value => this.handleSelect('assetType', value)}
                                                    placeholder={`Please Enter Asset Type`}
                                                >
                                                    {(this.state.typeList || []).map(item =>
                                                        <Select.Option key={item._id}
                                                            value={item._id}>{item.name}</Select.Option>)}
                                                </Select>)
                                                }
                                            </Form.Item>
                                        </Col>
                                        <Col xs={12} sm={12} md={24} lg={24} xl={24}>
                                            <Form.Item key={`submit`}>
                                                <Button type="primary" className="gx-mb-0" htmlType="submit"
                                                    loading={loading}>
                                                    Get Spares
                                                </Button>
                                            </Form.Item>
                                            <Form.Item key={`reset`}>
                                                <Button type="secondary" className="gx-mb-0" htmlType="button"
                                                    onClick={() => this.resetForm(this.props.form)}>
                                                    Reset
                                                </Button>
                                            </Form.Item>
                                            <Form.Item key={`download`}>
                                                <Button icon='download' type="secondary" className="gx-mb-0"
                                                    htmlType="button"
                                                    disabled={!fetchedIssueData || this.state.fetchedIssueData.length <= 0}
                                                    onClick={() => this.downloadCsv()}>
                                                    Download
                                                </Button>
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </Form>
                            </div>
                        </Panel>
                    </Collapse>
                    <div>
                        {spareTable}

                    </div>
                </Spin>
            </div>
        );
    }
}

const
    mapStateToProps = ({ auth, commonData }) => {
        return {
            authUser: auth.authUser,
            loading: commonData.loading,
            assetData: commonData.relationshipSearch,
            spareIssueData: commonData.assetSpareIssueData,
        };
    };

function

    mapDispatchToProps(dispatch) {
    return {
        fetchRelationshipSearchData,
        getSpareInventoryFilters,
        getAssetSpareIssueReport
    };
}

const AssetModelSpareIssueReport = Form.create({ name: 'asset-model-spare-issue-report' })(AssetSpareIssueReport);
export default connect(mapStateToProps, mapDispatchToProps())(AssetModelSpareIssueReport);
